import getOfferUrl from "./getOfferUrl";

/**
 * Join the offerUrl to a path
 * @param {*} offerUrl The offer URL
 * @param {*} path The page path
 */
const joinOfferUrlToPath = ({ offerUrl, path }) => (
  `${getOfferUrl(offerUrl)}${path}`
);

export default joinOfferUrlToPath;
